import { Directive, Injectable } from "@angular/core";
import { Observable } from "rxjs-compat";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: "root",
})
@Directive()
export class TimerService {
    private _trialEndsAt;
    private _diff: number;
    public _days: number;
    public _hours: number;
    public _minutes: number;
    public _seconds: number;

    constructor(public _apiService: ApiService) {}

    public getTime(timestamp) {
        let dateConstruct = new Date(timestamp * 1000).toLocaleDateString(
            "en-CA"
        );
        this._trialEndsAt = dateConstruct;
        Observable.interval(1000)
            .map((x) => {
                this._diff =
                    Date.parse(this._trialEndsAt) -
                    Date.parse(new Date().toString());
            })
            .subscribe((x) => {
                this._days = Math.abs(this.getDays(this._diff));
                this._hours = Math.abs(this.getHours(this._diff));
                this._minutes = Math.abs(this.getMinutes(this._diff));
                this._seconds = Math.abs(this.getSeconds(this._diff));
            });
    }

    getDays(t) {
        return Math.floor(t / (1000 * 60 * 60 * 24));
    }

    getHours(t) {
        return Math.floor((t / (1000 * 60 * 60)) % 24);
    }

    getMinutes(t) {
        return Math.floor((t / 1000 / 60) % 60);
    }

    getSeconds(t) {
        return Math.floor((t / 1000) % 60);
    }
}
